import { BuyerMeetingDto } from '@/services/booking';

export type MeetingsReducer = BuyerMeetingDto[] | null;

const meetings = (state: MeetingsReducer = null, action) => {
    switch (action.type) {
        case 'BUYER_SET_MEETINGS':
            return action.data;
        default:
            return state;
    }
};

export default meetings;
